<template>
  <el-dialog
    class="move-window-wrap dialog-email"
    ref="dialog"
    :title="dialogTitle"
    :visible.sync="visible"
    append-to-body
  >
    <template v-slot:default>
      <div @mousedown.capture.stop v-loading="isLoadingDialog" class="dialog-email__content">
        <el-form
          :model="form"
          ref="Form"
          class="dialog-email__form"
        >
          <native-scroll class="dialog-email__scroll">
            <div class="row">
              <div class="col-12">
                <div class="dialog-email__input-to">
                  <el-form-item
                    prop="emailToList"
                    :label="L10n('email-to-list')"
                    :rules="ruleEmailToList"
                    class="material-style"
                  >
                    <el-select
                      v-model="form.emailToList"
                      class="dialog-email__select-email"
                      multiple
                      filterable
                      allow-create
                      default-first-option
                      :placeholder="L10n('email')">
                      <el-option
                        v-for="(item, i) in emailOptions"
                        :key="i"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <span class="dialog-email__select-email-icon" @click.stop.prevent="_handleAddContacts">
                <i class="el-input__icon el-icon-plus"></i>
              </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-12">
                <el-form-item
                  :label="L10n('display-name')"
                  :rules="getValidationRule('required')"
                  prop="displayName"
                  class="material-style"
                >
                  <el-input
                    :value="form.displayName"
                    @input="form.displayName = valueTrimLeft($event)"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="col-md-6 col-12">
                <el-form-item
                  :label="L10n('reply-to')"
                  prop="replyTo"
                  class="material-style"
                >
                  <el-input
                    :value="form.replyTo"
                    @input="form.replyTo = valueTrimLeft($event)"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <el-form-item
                  :label="L10n('subject')"
                  :rules="getValidationRule('required')"
                  prop="subject"
                  class="material-style"
                >
                  <el-input
                    :value="form.subject"
                    @input="form.subject = valueTrimLeft($event)"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-12">
                <el-form-item
                  :label="L10n('body')"
                  prop="body"
                  class="material-style"
                >
                  <skill-editor
                    :model.sync="form.body"
                  ></skill-editor>
                </el-form-item>
              </div>
              <div class="col-lg-6 col-12">
                <el-form-item
                  :label="L10n('email-signature')"
                  prop="emailSignature"
                  class="material-style"
                >
                  <skill-editor
                    :model.sync="form.emailSignature"
                  ></skill-editor>
                </el-form-item>
              </div>
            </div>
          </native-scroll>
          <div class="dialog-email__footer">
            <div>
              <el-form-item
                prop="sendBulk"
                class="dialog-email__footer-item"
              >
                <el-checkbox
                  class="ellipsis"
                  v-model="form.sendBulk"
                  :label="L10n('send-bulk')"
                  :title="L10n('send-bulk')"
                />
              </el-form-item>
            </div>
            <div>
              <el-form-item
                prop="sendViaDefault"
                class="dialog-email__footer-item"
              >
                <el-checkbox
                  class="ellipsis"
                  v-model="form.sendViaDefault"
                  :label="L10n('send-via-default')"
                  :title="L10n('send-via-default')"
                />
              </el-form-item>
            </div>
            <div>
              <el-button @click.prevent="hide">
                {{L10n('close')}}
              </el-button>
            </div>
            <div>
              <el-button type="primary" @click.prevent="onSubmitForm" :disabled="isLoadingDialog">
                {{L10n('send')}}
              </el-button>
            </div>
          </div>
        </el-form>
      </div>
      <dialog-add-contacts
        ref="dialog-add-contact"
        @onComplete="handleComplete"
      />
    </template>
  </el-dialog>
</template>
<script>
import { MoveWindow } from '../mixins'
import { waitValue } from '@/utils/promises'
import { replaceContent } from '@/utils/templates'
import { api } from '@/services/api'

class MainSendEmailModel {
  constructor () {
    this.emailToList = []
    this.displayName = ''
    this.replyTo = ''
    this.subject = ''
    this.body = ''
    this.emailSignature = ''
    this.sendViaDefault = false
    this.sendBulk = true
  }
}

export default {
  name: 'DialogEmail',
  mixins: [MoveWindow],
  components: {
    'dialog-add-contacts': () => import(/* webpackChunkName: 'Dialogs' */ './DialogAddContacts'),
    'skill-editor': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/SkillEditor'),
    'native-scroll': () => import(/* webpackChunkName: 'Forms' */ '@/components/native-scroll')
  },
  props: {
    title: { default: '' },
    contentKey: { type: String, default: '' },
    contentMap: { type: Object, default: () => ({}) },
    data: { type: Object, default: () => ({}) },
    isLoading: { type: Boolean, default: false },
    customClass: { type: String, default: '' }
  },
  watch: {
    contentMap: 'debounceParse',
    data: 'debounceParse'
  },
  created () {
    this.form = this.defaultModel()
  },
  data () {
    return {
      visible: false,
      debounceParse: this.$_.debounce(this.parseData, 500),
      form: {},
      emailOptions: [],
      privateIsLoading: false
    }
  },
  computed: {
    dialogTitle () {
      return this.title || this.form.subject || this.L10n('subject')
    },
    currentUser () {
      return this.$store.getters.get('currentUser') || {}
    },
    isLoadingDialog () {
      return this.isLoading || this.privateIsLoading
    },
    ruleEmailToList () {
      return [
        {
          message: this.L10n('required'),
          required: true,
          trigger: ['change', 'blur'],
          validator: (rule, value, callback) => {
            let message = this.L10n('required')
            if (value && value.length) {
              callback()
            } else {
              callback(new Error(message))
            }
          }
        }
      ]
    }
  },
  methods: {
    defaultModel () {
      return this.copyObjectProps(new MainSendEmailModel(), {
        displayName: this.currentUser.emailDisplayName,
        emailSignature: this.currentUser.emailSignature || ''
      })
    },
    getData () {
      return Object.assign({}, this.form)
    },
    onSubmitForm () {
      this.validate()
        .then(() => {
          this.$emit('on-submit-email', { ...this.getData() })
        })
    },
    show () {
      this.visible = true
      this.$nextTick()
        .then(() => {
          this.mixModalToCenter()
        })
    },
    hide () {
      this.visible = false
    },
    handlerClose () {
      this.$emit('close')
    },
    parseData () {
      let body = ''
      return this.parseBody()
        .then((parsedBody) => {
          body = parsedBody
        })
        .then(() => {
          this.form = this.copyObjectProps(this.defaultModel(), { ...this.data, body })
          this.emailOptions = [...this.form.emailToList]
        })
    },
    async parseBody () {
      let content = await this._getContentByKey(this.contentKey)
      content = content || this.data.body || ''
      return replaceContent(content, this.contentMap)
    },
    validate (callback) {
      return this.$refs.Form.validate(callback)
    },
    // Private
    handleComplete (emailList) {
      const hashEmailList = this.form.emailToList.reduce((res, email) => {
        res[email] = email
        return res
      }, {})

      emailList.forEach((email) => {
        hashEmailList[email] = email
      })

      this.form.emailToList = Object.values(hashEmailList)
    },
    _handleAddContacts () {
      this.$refs['dialog-add-contact'].show()
    },
    _getContentByKey (contentKey) {
      if (!contentKey) {
        return Promise.resolve('')
      }
      this.privateIsLoading = true
      let params = {
        'filter': `contentKey == "${contentKey}"`
      }
      return api
        .get(`Contents/GetAllDynamic`, { params })
        .then(({ data }) => {
          this.privateIsLoading = false
          let value = ''
          if (data.value[0]) {
            let { html1, html2, html3 } = data.value[0]
            html1 = html1 || ''
            html2 = html2 || ''
            html3 = html3 || ''
            value = html1 + html2 + html3
          }
          return value
        })
        .catch(() => {
          this.privateIsLoading = false
          this.requestErrorHandler(new Error(`${this.L10n('error-load-content')} => ${contentKey}`))
          return null
        })
    },
    // MIXINS
    mixGetModalRef () {
      return waitValue(() => this.$refs.dialog)
        .then((dialog) => {
          return dialog.$el.firstElementChild
        })
    }
  }
}

</script>

<style lang="stylus">
  .el-dialog__wrapper.move-window-wrap{
    overflow hidden
    .el-dialog{
      margin 0 !important
      user-select none
      width 90%
      max-width 1200px
    }
  }
  .dialog-email{
    &__content {
      height 100%
    }
    &__form {
      display grid
      grid-template-rows 1fr auto
      height 100%
      grid-gap 1rem
      > * {
        min-width 0
      }
    }
    &__scroll {
      margin 0 -1.2rem
      padding 0 1.2rem
    }

    &__select-email{
      &-icon{
        &:hover{
          cursor: pointer;
        }
      }
    }
    &__input-to{
      display: flex;
      .el-form-item{
        width: 100%;
      }
    }

    &__footer {
      display grid
      grid-template-columns auto 1fr auto auto
      grid-gap 1rem
      & > * {
        min-width 0
      }
      &-item{
        padding 0
        margin 0
      }
    }

    .el-dialog{
      height calc(100% - 10rem)
      display flex
      flex-direction column
      &__body {
        flex 1 1 auto
        overflow hidden
      }
    }
  }

</style>
